/**************************************************
 * Nombre:       Dialogo_CheckOut
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {AssignmentReturn} from '@mui/icons-material'
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logoRedondo from "../../../Recursos/logo_redondo.png";
import Formulario_Reserva_Check_Out from "../../Formularios/Reservas/Formulario_Reserva_Check_Out";

const Dialogo_CheckOut = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad
    } = useFormulario({valoresDefecto: datos})
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'uno'
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        if (entidad.estado === 'Ocupada' || entidad.estado === 'Salida' ) {
            entidad.estado = 'Limpieza'
            entidad.fechaSalida = new Date().getTime()
        }

        console.log(entidad.estado)

        iniciarCarga('Subiendo Datos')
        let result = await guardarDoc('reservas', entidad)
        if (result.res) {
            terminar({aviso: 'Datos actualizados con exito'})
        } else {
            terminar({aviso: 'Ups! no se subieron los datos, intentalo nuevamente', variante: 'error'})
        }

    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Reserva_Check_Out props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    color={'secondary'}
                    onClick={() => subirDatos()}
                    startIcon={<AssignmentReturn/>}
                >Hacer Check Out</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_CheckOut